<app-widget-manager [widgets]="widgetItems" [column]="nbColumn" (widgetMoved)="widgetMoved($event)"> </app-widget-manager>
